// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"6c49feb5","80":"05ed6877","145":"7abc51c7","216":"39622d48","390":"55ffe396","597":"3387abf6","620":"e484b4f3","639":"c0340a93","686":"dfca303e","715":"d437dd06","725":"fa23c404","960":"de79fcde"}[chunkId] + ".chunk.js";
};